import { MediaContainer, Ovp, PlaybackType, AssetType } from "@sky-uk-ott/core-video-sdk-js";
import { testPreset } from "./testStreamPreset.js";
const presets = {
  NEWS_NOW: {
    initializationOptions: {
      appBrand: "nbcnews",
      appName: "nbcnews"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      serviceKey: "5676009166762707117",
      assetMetadata: {
        channelId: "NBC News Now",
        channelName: "nbc_news_now",
        programmeId: "NBC News Now",
        programmeTitle: "nbc_news_now",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CBC-4s/Live/channel(nnn)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CTR-4s/Live/channel(nnn)/master.mpd"
        }
      }
    }
  },
  MSNBC_TVE: {
    initializationOptions: {
      appBrand: "msnbc",
      appName: "nbcnews"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      serviceKey: "5608086763860174117",
      assetMetadata: {
        channelId: "MSNBC",
        channelName: "msnbc",
        programmeId: "MSNBC",
        programmeTitle: "msnbc",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CBC-4s/Live/channel(msnbc)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CTR-4s/Live/channel(msnbc)/master.mpd"
        }
      }
    }
  },
  TODAY_ALL_DAY: {
    initializationOptions: {
      appBrand: "today",
      appName: "nbcnews"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      serviceKey: "7989219137174638117",
      assetMetadata: {
        channelId: "Today",
        channelName: "today_all_day",
        programmeId: "Today",
        programmeTitle: "today_all_day",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CBC-4s/Live/channel(todayallday)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CTR-4s/Live/channel(todayallday)/master.mpd"
        }
      }
    }
  },
  CNBC: {
    initializationOptions: {
      appBrand: "cnbc",
      appName: "cnbc"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      serviceKey: "5724738528402108117",
      assetMetadata: {
        channelId: "CNBC",
        channelName: "cnbc",
        programmeId: "CNBC",
        programmeTitle: "cnbc",
        duration: 0,
        brand: "CNBC"
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd.akamaized.net/Content/CMAF_OL1-CBC-4s/Live/channel(cnbc)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL1-CTR-4s/Live/channel(cnbc)/master.mpd"
        }
      }
    }
  },
  CNBC_PRO: {
    initializationOptions: {
      appBrand: "cnbcpro",
      appName: "cnbc"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      serviceKey: "5724738528402108117",
      assetMetadata: {
        channelId: "CNBC Pro",
        channelName: "cnbc_pro",
        programmeId: "CNBC Pro",
        programmeTitle: "cnbc_pro",
        duration: 0,
        brand: "CNBC"
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL1-CBC-4s-v2/Live/channel(cnbc)/master_30min.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL1-CBC-4s-v2/Live/channel(cnbc)/master_30min.mpd"
        }
      }
    }
  },
  CNBC_GLOBAL: {
    initializationOptions: {
      appBrand: "cnbcplus",
      appName: "cnbc"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      serviceKey: "",
      assetMetadata: {
        channelId: "",
        channelName: "",
        programmeId: "",
        programmeTitle: "",
        duration: 0,
        brand: ""
      },
      assetByType: {
        hlsCBCS: {
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL1-CBC-4s-v2/Live/channel(cnbcpwog)/master_30min.m3u8",
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" }
        },
        dash: {
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL1-CTR-4s-v2/Live/channel(cnbcpwog)/master_30min.mpd",
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          }
        }
      }
    }
  },
  CNBC_DATA: {
    initializationOptions: {
      appBrand: "cnbc",
      appName: "cnbc"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      adsEnabled: false,
      serviceKey: "",
      assetMetadata: {
        channelId: "",
        channelName: "",
        programmeId: "",
        programmeTitle: "",
        duration: 0,
        brand: ""
      },
      assetByType: {
        hlsCBCS: {
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL1-CBC-4s-v2/Live/channel(cnbcpwithg)/master_30min.m3u8",
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" }
        },
        dash: {
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL1-CTR-4s-v2/Live/channel(cnbcpwithg)/master_30min.mpd",
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          }
        }
      }
    }
  },
  CNBC_FULLEPISODE: {
    initializationOptions: {
      appBrand: "cnbc",
      appName: "cnbc"
    },
    streamConfig: {
      playbackType: PlaybackType.VOD,
      serviceKey: "",
      assetMetadata: {
        channelId: "CNBC FULL EPISODE",
        channelName: "cnbc_full_episode",
        programmeId: "",
        programmeTitle: "",
        duration: 0,
        brand: "CNBC",
        type: AssetType.Episode
      },
      adsEnabled: {
        midRollAdEnabled: true,
        preRollAdEnabled: true
      },
      assetByType: {
        hlsCBCS: {
          url: "",
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "not_required" }
        },
        dash: {
          url: "",
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "not_required" }
        }
      }
    }
  },
  NOTICIAS_AHORA: {
    initializationOptions: {
      appBrand: "telemundo",
      appName: "nbcnews"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      // DRM-related
      keyId: "nota",
      serviceKey: "7536064712744877117",
      assetMetadata: {
        channelId: "Noticias Telemundo Ahora",
        channelName: "noticias_telemundo_ahora",
        programmeId: "Noticias Telemundo Ahora",
        programmeTitle: "noticias_telemundo_ahora",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CBC-4s/Live/channel(nota)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CTR-4s/Live/channel(nota)/master.mpd"
        }
      }
    }
  },
  TELEMUNDO_DEPORTES_AHORA: {
    initializationOptions: {
      appBrand: "telemundo",
      appName: "nbcnews"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      // DRM-related
      keyId: "telemundodeportes",
      serviceKey: "5923023667697108117",
      assetMetadata: {
        channelId: "Telemundo Deportes Ahora",
        channelName: "telemundo_deportes_ahora",
        programmeId: "Telemundo Deportes Ahora",
        programmeTitle: "telemundo_deportes_ahora",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://g001-live-us-cmaf-prd-ak.pcdn03.cssott.com/Content/CMAF_OL2-CBC-4s/Live/channel(telemundodeportes)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://g001-live-us-cmaf-prd-ak.pcdn03.cssott.com/Content/CMAF_OL2-CTR-4s/Live/channel(telemundodeportes)/master.mpd"
        }
      }
    }
  },
  DATELINE: {
    initializationOptions: {
      appBrand: "nbcnews",
      appName: "nbcnews"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      // DRM-related
      keyId: "dateline",
      serviceKey: "7509458937090982117",
      assetMetadata: {
        channelId: "Dateline",
        channelName: "dateline",
        programmeId: "Dateline",
        programmeTitle: "dateline_247",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CBC-4s/Live/channel(dateline)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CTR-4s/Live/channel(dateline)/master.mpd"
        }
      }
    }
  },
  SKY_NEWS: {
    initializationOptions: {
      appBrand: "skynews",
      appName: "nbcnews"
    },
    streamConfig: {
      playbackType: PlaybackType.Live,
      // DRM-related
      keyId: "skynews",
      serviceKey: "4718718353051323117",
      assetMetadata: {
        channelId: "SkyNews",
        channelName: "sky_news",
        programmeId: "SkyNews",
        programmeTitle: "skynews",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CBC-4s/Live/channel(skynews)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd-news.akamaized.net/Content/CMAF_OL2-CTR-4s/Live/channel(skynews)/master.mpd"
        }
      }
    }
  },
  TELEMUNDO_AL_DIA: {
    initializationOptions: {
      appName: "nbcnews",
      appBrand: "telemundo"
    },
    streamConfig: {
      serviceKey: "4743269032877988117",
      playbackType: PlaybackType.Live,
      // DRM-related
      keyId: "telemundoaldia",
      assetMetadata: {
        channelId: "Telemundo Al Dia",
        channelName: "telemundo_al_dia",
        programmeId: "Telemundo Al Dia",
        programmeTitle: "telemundo_al_dia",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: { encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1" },
          url: "https://live-oneapp-prd.akamaized.net/Content/CMAF_OL2-CBC-4s/Live/channel(telemundoaldia)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://live-oneapp-prd.akamaized.net/Content/CMAF_OL2-CTR-4s/Live/channel(telemundoaldia)/master.mpd"
        }
      }
    }
  },
  NBC_SPORTS: {
    initializationOptions: {
      appName: "nbcnews",
      appBrand: "nbcsports"
    },
    streamConfig: {
      serviceKey: "4743269032877988118",
      playbackType: PlaybackType.Live,
      // DRM-related
      keyId: "nbcsportspeacock",
      assetMetadata: {
        channelId: "NBC Sports",
        channelName: "nbc_sports",
        programmeId: "NBC Sports",
        programmeTitle: "nbc_sports",
        duration: 0
      },
      assetByType: {
        hlsCBCS: {
          transport: Ovp.StreamTransport.HLS,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-hls-30fps-NBCS-Oneapp-v1"
          },
          url: "https://g001-live-us-cmaf-prd-ak.pcdn03.cssott.com/Content/CMAF_OL2-CBC-4s/Live/channel(nbcsportspeacock)/master.m3u8"
        },
        dash: {
          transport: Ovp.StreamTransport.DASH,
          container: MediaContainer.ISOBMFF,
          adCompatibility: {
            encodingProfile: "cmaf-dash-30fps-NBCS-Oneapp-v1"
          },
          url: "https://g001-live-us-cmaf-prd-ak.pcdn03.cssott.com/Content/CMAF_OL2-CTR-4s/Live/channel(nbcsportspeacock)/master.mpd"
        }
      }
    }
  }
};
function mergeInto(dest, src) {
  Object.keys(dest).forEach((key) => {
    if (src[key]) {
      dest[key] = src[key];
    }
  });
}
function getPreset(presetId, vodMetadata, streamData) {
  if (presetId === "TEST") {
    return testPreset;
  }
  let preset = presets[presetId];
  if (!preset) {
    return void 0;
  }
  preset = structuredClone(preset);
  const streamConfig = preset.streamConfig;
  if (presetId.includes("CNBC") && presetId !== "CNBC_FULLEPISODE" && streamData) {
    streamConfig.serviceKey = streamData.serviceKey || streamConfig.serviceKey;
    streamConfig.adsEnabled = streamData.adsEnabled !== void 0 ? streamData.adsEnabled : streamConfig.adsEnabled;
    mergeInto(streamConfig.assetMetadata, streamData);
    if (streamData.safariStreamingUrl && streamData.streamingUrl) {
      streamConfig.assetByType.hlsCBCS.url = streamData.safariStreamingUrl;
      streamConfig.assetByType.dash.url = streamData.streamingUrl;
    }
  } else if (presetId === "CNBC_FULLEPISODE" && vodMetadata) {
    streamConfig.serviceKey = vodMetadata.externalAdvertiserId || "";
    const { assetMetadata } = streamConfig;
    assetMetadata.programmeId = vodMetadata.seasonAndEpisodeNumber || "";
    assetMetadata.programmeTitle = vodMetadata.seriesTitle || "";
    assetMetadata.duration = vodMetadata.duration || 0;
    streamConfig.assetByType.hlsCBCS.url = vodMetadata.streamingUrl || "";
    streamConfig.assetByType.dash.url = vodMetadata.streamingUrl || "";
    streamConfig.adsEnabled = vodMetadata.adsEnabled !== void 0 ? vodMetadata.adsEnabled : streamConfig.adsEnabled;
  }
  return preset;
}
export {
  getPreset
};
//# sourceMappingURL=demoAppConfigPresets.js.map
